// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contGrid {
    display: grid;
    justify-items: center;
}

.contGridItem {
    height: 80px;
    width: 80px;
    border: 1px solid lightgray;
    margin: 5px;
    align-self: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    cursor: default;
    position: relative;
    word-break: break-word;
    overflow: hidden;
}

.contGridUniqueID {
    font-size: 11px;
    position: absolute;
    right: 0px;
    bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/common/query.relation.overview.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf","sourcesContent":[".contGrid {\n    display: grid;\n    justify-items: center;\n}\n\n.contGridItem {\n    height: 80px;\n    width: 80px;\n    border: 1px solid lightgray;\n    margin: 5px;\n    align-self: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    cursor: default;\n    position: relative;\n    word-break: break-word;\n    overflow: hidden;\n}\n\n.contGridUniqueID {\n    font-size: 11px;\n    position: absolute;\n    right: 0px;\n    bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
